// Tooltip.tsx
import React from "react";
import { View, Text, StyleSheet, Image, ScrollView } from "react-native";

import { TouchableOpacity } from "react-native-gesture-handler";
import { AppImages } from "../../../../utility/AppImages";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import Separator from "../../../../Components/Separator";

type HowWorksTooltipProps = {
  visible: boolean;
  setVisible?: any;
  width?: any;
  right?: number;
  boxViewStyle?: any;
  closeBtnMargin?: number;
  closeImage?: any;
  bottom?: number;
  tooltipStyle?: any;
};

const checkInSteps = [
  {
    header: "Why Check-In Matters",
    text: "Check-In ensures you're ready to participate and lets the organizer track who’s attending. If someone doesn’t check in, adjustments like adding waitlisted participants can be made.",
  },
  {
    header: "Get Notified Before the Event",
    text: "You’ll receive a reminder before check-in opens, so you won’t miss the chance to confirm your participation.",
  },
  {
    header: "Countdown to Check-In",
    text: "Once the reminder is sent, a countdown timer will appear on the event page, showing how much time is left to check in.",
  },
  {
    header: "Confirm Your Spot",
    text: "Tap the 'Check-In' button on the event page to confirm your availability.",
  },
];

const HowWorksTooltip: React.FC<HowWorksTooltipProps> = ({
  visible,
  setVisible,
  width = "auto",
  right = 20,
  boxViewStyle = {},
  closeBtnMargin = 0,
  bottom = -50,
  closeImage = AppImages.icCloseWhiteSvg,
  tooltipStyle,
}) => {
  if (!visible) return null;

  return (
    <View
      style={[
        styles.tooltipContainer,
        tooltipStyle,
        {
          width: width,
          right: right,
          bottom: bottom,
          zIndex: 2000,
        },
      ]}
    >
      <View style={styles.tooltip}>
        <View style={{ gap: 12 }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text style={AppFontStyle.BOLD_ANYBODY_20}>
              How does check-in works?
            </Text>{" "}
            <TouchableOpacity
              onPress={() => {
                setVisible(false);
              }}
              style={{ alignItems: "flex-end" }}
            >
              <Image
                source={closeImage}
                style={{
                  height: 16,
                  width: 16,
                  marginBottom: closeBtnMargin,
                }}
              />
            </TouchableOpacity>
          </View>

          {checkInSteps.map((step, index) => (
            <>
              <Separator
                color={AppColors.black_2D2733}
                height={1}
                marginTop={0}
                marginBottom={0}
                marginHorizontal={0}
              />
              <View key={index} style={{ gap: 6 }}>
                <Text style={styles.header}>{step.header}</Text>
                <Text style={styles.text}>{step.text}</Text>
              </View>
            </>
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  tooltipContainer: {
    position: "absolute",
    bottom: 30,
    zIndex: 1000,
    alignItems: "center",
  },
  tooltip: {
    padding: 12,
    borderRadius: 12,
    backgroundColor: AppColors.purple_453B50,
  },
  header: {
    ...AppFontStyle.SEMIBOLD_ANYBODY_16,
  },
  text: {
    ...AppFontStyle.REGULAR_ANYBODY_14,
  },
});

export default HowWorksTooltip;
